import React from 'react';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {Page, Section, HighlightPanel, CaseStudies} from 'epic-ue-components';
import {SectionWrapper, HomepageWrapper, NewsSection} from './Homepage.styles';
import {useLoading, useNotFound} from '../../utils/loadingUtils';
import LoadIndicator from '../../components/common/loading/LoadIndicator';
import Error404 from '../error/Error404';

interface Properties {
    pageData: any;
}

const NewsContainer = ({pageData}: Properties) => {
    const isLoading = useLoading(pageData);
    const notFound = useNotFound(pageData);

    if (isLoading) {
        return <LoadIndicator fill />;
    }

    if (notFound) {
        return <Error404 />;
    }

    const bgImage = pageData.bgImg || '';
    const content = pageData.content || {};
    const bottomContent = pageData.bottomContent || {};
    const news = pageData.news || {};
    const panels = news.panels || [];
    const sections = content.sections || [];
    const bottomSections = bottomContent.sections || [];
    const showcase = pageData.showcase || {};

    let sectionList = <div />;
    if (sections) {
        sectionList = sections.map((section, i) => {
            let even = false;
            if (i % 2 === 0) {
                even = true;
            }
            return <Section key={`s-${i}-${section.title}`} {...section} even={even} />;
        });
    }

    let bottomSectionList = <div />;
    if (bottomSections) {
        bottomSectionList = bottomSections.map((section, i) => {
            let even = false;
            if (i % 2 === 0) {
                even = true;
            }
            return <Section key={`s-${i}-${section.title}`} {...section} even={even} />;
        });
    }

    let highlightList = <div />;
    if (panels) {
        highlightList = panels.map((panel, i) => {
            return <HighlightPanel key={`highlight-${i}-${panel.title}`} {...panel} />;
        });
    }

    return (
        <Page>
            {getHelmetForMetaTags(pageData)}
            <HomepageWrapper className="news-container">
                <SectionWrapper bgImg={bgImage}>{sectionList}</SectionWrapper>
                <CaseStudies {...showcase} />
                <NewsSection>
                    <div className="container">
                        <div className="row">{highlightList}</div>
                    </div>
                </NewsSection>
                <SectionWrapper bgImg="">{bottomSectionList}</SectionWrapper>
            </HomepageWrapper>
        </Page>
    );
};

export default NewsContainer;
